import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CurrencyPipe, DatePipe } from '@angular/common'; 
import { StoreModule} from '@ngrx/store';
import { RouterStateSerializer,
  StoreRouterConnectingModule, FullRouterStateSerializer}                       from '@ngrx/router-store';
import { CustomSerializer }                           from './state/reducers/router.reducer';
import { NgIdleModule } from '@ng-idle/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule, StoreDevtoolsOptions} from '@ngrx/store-devtools'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { effects }  from './state/effects';
import {reducers} from './state/reducers';
import { RouteReuseStrategy } from '@angular/router'; 
import { EnvironmentModule } from './environment/environment.module';
import { RouteReuseStrategyService } from './feature/writeups-leads/services/route-reuse-strategy.service';
import { MatDialogModule,MatDialogRef } from '@angular/material/dialog';
import {MatSnackBarModule} from '@angular/material/snack-bar'

const storeDevtoolsOptions = { name: 'Management Console', maxAge: 25, connectInZone: true } as StoreDevtoolsOptions;
@NgModule({
  declarations: [
    AppComponent,
    // SplitString 
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    EnvironmentModule,
    CoreModule,
    SharedModule,
    NgIdleModule.forRoot(),
    StoreModule.forRoot(reducers,{
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
      },
    }),
    EffectsModule.forRoot(effects),
    StoreRouterConnectingModule.forRoot({ serializer: FullRouterStateSerializer }), 
    StoreDevtoolsModule.instrument(storeDevtoolsOptions),
    AppRoutingModule,
    MatDialogModule,
    MatSnackBarModule,
  ],
  providers: [
    DatePipe,
    CurrencyPipe,
    {
      provide: MatDialogRef,
      useValue: {}
    },
    { provide: RouterStateSerializer, useClass: CustomSerializer },
    {provide: RouteReuseStrategy, useClass: RouteReuseStrategyService}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
